<template>
  <div :class="[
    'menu__burger',
    theme,
    {
      vertical: isMobileVertical && !embedded,
      landscape: isMobileLandscape && !embedded,
      'menu__burger--embedded': embedded,
      'menu__burger--open': isPopupOpen || isJackpotPopupOpen,
    },
  ]" @click="toggleClose">
    <span class="menu__burger__span"></span>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import { PopupPage } from '@/utils/index.model';
  import { isMobile } from 'mobile-device-detect';

  export default {
    props: {
      embedded: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        defaultContainerStyle: {
          position: 'relative',
          maxWidth: '30px',
        },
      };
    },
    computed: {
      ...mapGetters({
        isPopupOpen: 'menu/isPopupOpen',
        isJackpotPopupOpen: 'menu/isJackpotPopupOpen',
        theme: 'general/theme',
      }),
      isMobileLandscape() {
        return isMobile && this.$screen.width > this.$screen.height;
      },
      isMobileVertical() {
        return isMobile && this.$screen.width < this.$screen.height;
      },
    },
    methods: {
      ...mapActions('menu', ['updateMenu']),
      toggleClose() {
        if (this.isJackpotPopupOpen) {
          this.updateMenu({
            isJackpotPopupOpen: false,
          });
        } else {
          this.updateMenu({
            isPopupOpen: !this.isPopupOpen,
            activePopupPage: PopupPage.history,
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

  html,
  body {
    background-color: lightcyan;
  }

  .menu {
    $root: &;

    &__burger {
      $burger: #{$root}__burger;
      width: 32px;
      height: 32px;
      right: 0;
      cursor: pointer;
      z-index: 99;
      border: solid 1px rgba(105, 120, 162, 0.8);
      background-image: linear-gradient(to bottom, #333f60, #616f98);
      border-radius: 50%;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none;
      position: relative;
      z-index: 5000;
      @include user-select-none();
      margin: 0;

      &--embedded {
        position: static;
        bottom: auto;
        right: auto;
        border: 0;
        background: transparent;
      }

      &.world-cup:not(.menu__burger--open) {
        background-image: url('~@/assets/images/logos/worldcup-logo.webp');
        background-size: cover;
        background-position: center;
        border: none;
        width: 33px;
        height: 36px;
        border-radius: 0;

        .menu__burger__span {
          display: none;
        }
      }

      &__span {
        position: absolute;
        height: 2px;
        width: inherit;
        background-color: #8596c4;
        transition: all 0.2s;
        width: 19px;

        &:before {
          @extend #{$burger}__span;
          content: '';
          top: -5px;
          left: 3px;
          width: 14px;
        }

        &:after {
          @extend #{$burger}__span;
          content: '';
          top: 5px;
          left: 3px;
          width: 14px;
        }
      }

      &--open {
        #{$burger}__span {
          background-color: transparent;

          &:before,
          &:after {
            background-color: #8596c4;
            transform-origin: 0 50%;
          }

          &:before {
            transform: translateX(1px) translateY(0px) rotate(45deg);
          }

          &:after {
            transform: translateX(1px) translateY(0px) rotate(-45deg);
          }
        }
      }

      &.vertical {
        position: fixed;
        bottom: 28px;
        right: 16px;
      }

      &.landscape {
        position: fixed;
        bottom: 8px;
        right: 16px;
      }
    }
  }
</style>
